export default {
  install: (app, options) => {
    const { AuthlessApiService } = options;
    const { globalProperties } = app.config;
    const authlessApiService = new AuthlessApiService(app);
    globalProperties.$authlessApiService = () => {
      return authlessApiService;
    };

    if (!globalProperties.$store) {
      throw new Error("No connected store was provided");
    }
    globalProperties.$store.$authlessApiService =
      globalProperties.$authlessApiService;
  },
};
